import { render, staticRenderFns } from "./DashboardTotalCoupon.vue?vue&type=template&id=6d125112&"
import script from "./DashboardTotalCoupon.vue?vue&type=script&lang=js&"
export * from "./DashboardTotalCoupon.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTotalCoupon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports